import React from "react";
import { Create } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { EldForm } from "./EldForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface IEldCreateProps {}

export const EldCreate = (props: IEldCreateProps) => {
  const notify = useNotification(props, "createSuccess");
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.master-elds.title.create">
      <EldForm />
    </Create>
  );
};
